import { api } from '../services/api';
import { FETCH_SENSOR_PATH, FETCH_TIPO_SENSOR_PATH, FETCH_VALOR_SENSOR_TRAMA_PATH } from '../services/path';
import {
  FETCH_SENSOR,
  FETCH_SENSOR_BUSCAR,
  FETCH_SENSOR_BY_ID,
  FETCH_SENSOR_BY_ID_GRAFICA,
  FETCH_TIPO_SENSOR,
  FETCH_VALOR_SENSOR_TRAMA_BY_SENSOR_ID,
  LIMPIAR_ESTADO_SENSOR,
  UPDATE_SENSOR_REQUEST,
  UPDATE_SENSOR_SUCCESS,
  UPDATE_SENSOR_ERROR,
} from './types';

export const fetchSensor = (perPage, offSet) => (dispatch) => dispatch({
  type: FETCH_SENSOR,
  promise: api.get(`${FETCH_SENSOR_PATH}?perPage=${perPage}&offSet=${offSet}`)
});
export const fetchTipoSensor = () => (dispatch) => dispatch({
  type: FETCH_TIPO_SENSOR,
  promise: api.get(FETCH_TIPO_SENSOR_PATH)
});

export const fetchSensorById = (id) => (dispatch) => dispatch({
  type: FETCH_SENSOR_BY_ID,
  promise: api.get(`${FETCH_SENSOR_PATH}/${id}`)
});

export const fetchSensorByIdGrafica = (id) => (dispatch) => dispatch({
  type: FETCH_SENSOR_BY_ID_GRAFICA,
  promise: api.get(`${FETCH_SENSOR_PATH}/${id}`)
});

export const fetchValorSensorTramaById = (id) => (dispatch) => dispatch({
  type: FETCH_VALOR_SENSOR_TRAMA_BY_SENSOR_ID,
  promise: api.get(`${FETCH_VALOR_SENSOR_TRAMA_PATH}/sensor/${id}/grafica`)
});

export const fetchBuscarSensor = (perPage, offSet, texto) => (dispatch) => dispatch({
  type: FETCH_SENSOR_BUSCAR,
  promise: api.get(`${FETCH_SENSOR_PATH}/buscar?texto=${texto}&perPage=${perPage}&offSet=${offSet}`)
});

export const updateSensor = (id, sensorData) => async (dispatch) => {
  dispatch({ type: UPDATE_SENSOR_REQUEST });
  
  try {
    const response = await api.patch(`${FETCH_SENSOR_PATH}/${id}`, sensorData);
    
    dispatch({
      type: UPDATE_SENSOR_SUCCESS,
      payload: response.data
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: UPDATE_SENSOR_ERROR,
      payload: error.response?.data?.message || error.message
    });
    
    throw error;
  }
};

export const limpiarSensor = () => (dispatch) => dispatch({
  type: LIMPIAR_ESTADO_SENSOR,
});
